import type { User } from '@/models/User';
import type { Dict } from 'mixpanel-browser';

import mixpanel from 'mixpanel-browser';

import { isAnalyticsEnabled } from '@/utils/storage';

export function initializeMixpanel() {
  return new Promise<void>((resolve) => {
    mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
      api_host: 'https://api-eu.mixpanel.com',
      debug: import.meta.env.DEV,
      ip: false,
      loaded: () => resolve(),
    });
  });
}

export function identifyUser(user: User, language: string) {
  const { ExternalPersonReference, CompanyId, Country } = user;

  const shouldIdentifyUser = ExternalPersonReference !== mixpanel.get_distinct_id();

  if (shouldIdentifyUser) {
    setMixpanelProfile(ExternalPersonReference, {
      Country,
      CompanyId,
      'Course page version': 'new',
      Language: language,
    });
  }
}

const excludedPaths: string[] = ['/normal/', '/single/', '/bite/'];

const isExcludedPath = (): boolean => {
  return excludedPaths.some((path: string) => window.location.pathname.includes(path));
};

const disectPath = () => {
  const regex =
    /(^\/+(?<locale>\w{2}-\w{2}))?(\/+[^/.]+)*\/+((?<pagename>[^.]+)(?<extension>\.[^.]*$|$))/i;

  const { pathname, host } = window.location;
  const { locale, pagename } = regex.exec(pathname)?.groups ?? {};

  return { pathname, locale, pagename, host };
};

export function setMixpanelProfile(uniqueId: string, properties: Dict) {
  if (!isAnalyticsEnabled()) return;

  try {
    mixpanel.identify(uniqueId);
    mixpanel.people.set(properties);
  } catch (error) {
    console.error(error);
  }
}

export function track(eventName: string, properties?: Dict) {
  if (!isAnalyticsEnabled()) return;

  if (isExcludedPath()) return;

  const richProperties = { ...disectPath(), ...properties };

  try {
    mixpanel.track(eventName, richProperties);
  } catch (error) {
    console.error(error);
  }
}
